import React, { useState, useEffect, useMemo } from "react";
import HomeDashboard from "../components/HomeDashboard";

// Sample only (uses built-in mock data)
export default function Dashboard() {
  return (
    <div>
      {/* other landing sections */}
      <HomeDashboard />
    </div>
  );
}
